import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';

import type { Billable, Event } from '@feathr/blackbox';
import { Alert, ModalV1 } from '@feathr/components';
import { useLocalUrl } from '@feathr/extender/state';

interface IProps {
  event: Event;
  billable: Billable;
  toggleShowAddAddressModal: () => void;
}

function AddAddress({ event, billable, toggleShowAddAddressModal }: IProps) {
  const localUrl = useLocalUrl();
  const { t } = useTranslation();
  const history = useHistory();
  return (
    <ModalV1
      confirmButtonText={t('Edit Billing Configuration')}
      controlled={true}
      onClose={toggleShowAddAddressModal}
      onConfirm={async () => {
        history.push(localUrl(billable.getItemUrl('edit')));
      }}
      size={'sm'}
      t={t}
      title={t('Address Required')}
    >
      <Alert
        description={
          <Trans t={t}>
            Please add an address to the billing configuration, or{' '}
            <a href={localUrl(event.getItemUrl('settings/billing/edit'))}>replace</a> this project's
            billing configuration with one that has an address.
          </Trans>
        }
        title={t('Address required to add pre-paid funds')}
        type={'warning'}
      />
    </ModalV1>
  );
}

export default AddAddress;
